import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import * as _moment from 'moment';
import { Moment } from 'moment';
const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MM/YYYY',
    dateA11yLabel: 'MM/YYYY',
    monthYearA11yLabel: 'MM/YYYY',
  }
};
@Component({
  selector: 'app-bottom-sheet-search',
  templateUrl: './bottom-sheet-search.component.html',
  styleUrls: ['./bottom-sheet-search.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class BottomSheetSearchComponent implements OnInit {
  searchForm: FormGroup;

  constructor(private matBottomSheetRef: MatBottomSheetRef<BottomSheetSearchComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public searchClause: any) { }

  ngOnInit() {
    this.searchForm = new FormGroup({
      t: new FormControl(this.searchClause.t),
      dal: new FormControl(this.searchClause.dal ? this.searchClause.dal : null),
      al: new FormControl(this.searchClause.al ? this.searchClause.al : null),
      dalR: new FormControl(this.searchClause.dalR ? this.searchClause.dalR : null),
      alR: new FormControl(this.searchClause.alR ? this.searchClause.al : null)
    })
  }

  search(): void {
    this.matBottomSheetRef.dismiss(this.searchForm.value);
  }

  clearField(field: string, e: Event) {
    e.stopPropagation();
    this.searchForm.controls[field].setValue('');
  }

  setMonth(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, ctrl: string, end: boolean) {
    var ctrlValue = moment();
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    ctrlValue = ctrlValue[end ? "endOf" : "startOf"]("month");
    this.searchForm.controls[ctrl].setValue(ctrlValue);
    datepicker.close();
  }

}
